module.exports = __webpack_public_path__ + "static/media/信息安全管理体系认证.c8598b7f.png";